import {
    DELETE_HISTORY_ITEM,
    HISTORY_ITEM_HIGHLIGHT,
    HISTORY_ITEM_VISIBLE_CHANGE,
    NEW_EDIT,
    PERMANENT_DELETE_HISTORY_ITEM,
    PERMANENT_RESET_HISTORY,
    RESET_HISTORY,
    UNDO_DELETE_HISTORY_ITEM,
    UNDO_RESET_HISTORY
} from '../actions/EditHistoryActions';
import map from 'lodash/map';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import indexOf from 'lodash/indexOf';
import find from 'lodash/find';
import {SWITCH_IMAGE_SUCCESS} from '../actions/ImageActions';
import {EDIT_HIGHLIGHT_COLOR} from '../Constants';
import {Transformation} from 'rc-canvas/lib/Transformation';

const initState = {
    lastDelete: null,
    lastDeleteTimeoutId: null,
    lastReset: null,
    lastResetTimeoutId: null,
    edits: null,
    highlight: null,
};

const extractEdits = (imageInfo) => {
    if (!imageInfo.edits) {
        return [];
    }
    return imageInfo.edits.map(e => {
        const path = JSON.parse(e.path);
        const historyProps = JSON.parse(e.historyProps);
        if (historyProps && historyProps.transformation) {
            historyProps.transformation = Transformation.fromJs(historyProps.transformation);
        }
        return {...e, path, historyProps};
    });
};

function editHistoryReducer(state = initState, action) {
    let {edits} = state;
    if (!edits) {
        edits = [];
    }
    switch (action.type) {
        case NEW_EDIT:
            return {
                ...state,
                edits: [...edits, action.historyItem],
                lastDelete: null,
                lastReset: []
            };
        case HISTORY_ITEM_VISIBLE_CHANGE: {
            const idx = findIndex(edits, ['uuid', action.uuid]);
            if (idx < 0) {
                return state;
            }
            const item = edits[idx];
            return {
                ...state,
                edits: [...edits.slice(0, idx), {...item, hidden: !item.hidden}, ...edits.slice(idx + 1)]
            };
        }
        case DELETE_HISTORY_ITEM: {
            const idx = findIndex(edits, ['uuid', action.uuid]);
            if (idx < 0) {
                return state;
            }
            const item = edits[idx];
            return {
                ...state,
                edits: [...edits.slice(0, idx), {...item, deleted: true}, ...edits.slice(idx + 1)],
                lastDelete: action.uuid,
                lastDeleteTimeoutId: action.timeoutId
            };
        }
        case UNDO_DELETE_HISTORY_ITEM: {
            if (action.uuid !== state.lastDelete) {
                return {...state, lastDelete: null, lastDeleteTimeoutId: null};
            }
            if (state.lastDeleteTimeoutId) {
                clearTimeout(state.lastDeleteTimeoutId);
            }
            const idx = findIndex(edits, ['uuid', action.uuid]);
            if (idx < 0) {
                return state;
            }
            const item = edits[idx];
            return {
                ...state,
                edits: [...edits.slice(0, idx), {...item, deleted: false}, ...edits.slice(idx + 1)],
                lastDelete: null,
                lastDeleteTimeoutId: null,
            };
        }
        case PERMANENT_DELETE_HISTORY_ITEM: {
            const idx = findIndex(edits, ['uuid', action.uuid]);
            if (idx < 0) {
                return state;
            }
            return {
                ...state,
                edits: [...edits.slice(0, idx), ...edits.slice(idx + 1)],
                lastDelete: null,
                lastDeleteTimeoutId: null,
            };
        }
        case RESET_HISTORY: {
            const lastReset = [];
            edits = map(edits, (item) => {
                if (indexOf(action.uuids, item.uuid) < 0) {
                    return item;
                }
                if (!item.deleted) {
                    lastReset.push(item.uuid);
                    return {...item, deleted: true};
                }
                return item;

            });
            return {...state, edits, lastReset, lastResetTimeoutId: action.timeoutId};
        }
        case UNDO_RESET_HISTORY: {
            const {lastReset, lastResetTimeoutId} = state;
            if (lastResetTimeoutId) {
                clearTimeout(lastResetTimeoutId);
            }
            if (!lastReset) {
                return {...state, lastResetTimeoutId: null};
            }
            edits = map(edits, (item) => {
                if (indexOf(lastReset, item.uuid) < 0) {
                    return item;
                }
                return {...item, deleted: false};
            });
            return {...state, edits, lastReset: null, lastResetTimeoutId: null};
        }
        case PERMANENT_RESET_HISTORY: {
            const {lastReset} = state;
            if (!lastReset) {
                return state;
            }
            edits = filter(edits, (item) => {
                return indexOf(lastReset, item.uuid) < 0;
            });
            return {...state, edits, lastReset: null, lastResetTimeoutId: null};
        }
        case SWITCH_IMAGE_SUCCESS: {
            if (!state.edits) {
                return {...state, edits: extractEdits(action.imageInfo)};
            }
            break;
        }
        case HISTORY_ITEM_HIGHLIGHT:
            if (!action.on) {
                return {...state, highlight: null};
            }
            let highlight = find(edits, ['uuid', action.uuid]);
            highlight = {...highlight, brushColor: EDIT_HIGHLIGHT_COLOR};
            return {...state, highlight};
        default:
            break;
    }
    return state;
}

export function editHistory(state = {}, action) {
    const id = action.id || action.imageId;
    if (id) {
        const oldEditHistory = state[id] || initState;
        const newEditHistory = editHistoryReducer(oldEditHistory, action);
        if (oldEditHistory !== newEditHistory) {
            return {...state, [id]: newEditHistory};
        }
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/editHistory.js